import { AppState, HomePageSingaporeAppState } from '../../../initialStateRegistration';
import { HomePageSingaporeMinorSections, HomePageSingaporeTopSection } from './homePageSingapore.initalState';

export const getHomePage = (state: AppState) => (state as HomePageSingaporeAppState).template;

export const getSectionDataByKey = (key: HomePageSingaporeMinorSections | HomePageSingaporeTopSection) => (state: AppState) => getHomePage(state)[key];

export const getSectionArticlesByKey = (key: HomePageSingaporeMinorSections | HomePageSingaporeTopSection) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionTitleByKey = (key: HomePageSingaporeMinorSections) => (state: AppState) => getHomePage(state)[key].sectionTitle;

export const getMoreButtonTextByKey = (key: HomePageSingaporeMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonText;

export const getMoreButtonSvgByKey = (key: HomePageSingaporeMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonSvg;

export const getMetadataDescription = (state: AppState) => getHomePage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getHomePage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;

export const getHreflangData = (state: AppState) => getHomePage(state).hreflangData;
